import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Button from '../../../../components/Button';
import CNPJItem from './CNPJItem';

import { formatCpfAndCnpj, parseCpfAndCnpj } from '../../../../utils/parsers-formatters';
import {
  required,
  validRootOrCompleteCNPJAndCPF,
  validRootOrCompleteCNPJAndCPFAndAllowEmpty,
} from '../../../../utils/validators';

import './styles.css';

class CNPJList extends Component {
  _addCNPJ = () => {
    this.props.fields.push({});
  };

  render() {
    const { fields } = this.props;

    return (
      <div>
        <div className="CNPJList__form-section-label">CNPJ/raíz de CNPJ/CPF</div>
        {fields.map((member, index, fields) => (
          <Field
            key={index}
            name={`${member}.cnpj`}
            hintText="00.000.000/0000-00 - 000.000.000-00"
            fullWidth
            props={{
              cnpj: '',
              onRemove: () => fields.remove(index),
              hasInputField: fields.length === index + 1,
              renderAddButton: (invalid, value) => (
                <Button
                  block
                  type="button"
                  skin="gray-light"
                  text="ADICIONAR OUTRO CNPJ/CPF"
                  disabled={invalid || value === ''}
                  onClick={this._addCNPJ}
                />
              ),
            }}
            format={formatCpfAndCnpj}
            parse={parseCpfAndCnpj}
            validate={
              index === 0
                ? [required, validRootOrCompleteCNPJAndCPF]
                : validRootOrCompleteCNPJAndCPFAndAllowEmpty
            }
            component={CNPJItem}
          />
        ))}
      </div>
    );
  }
}

CNPJList.propTypes = {
  member: PropTypes.string,
  index: PropTypes.number,
  fields: PropTypes.object,
};

export default CNPJList;
